import { createSimpleRegionFunctions } from "./region-functions-simple";

// Dutch phone number format: +31 or 0
export const NLRegionFunctions = createSimpleRegionFunctions({
	countryCode: "+31",
	phonePrefix: "0",
});
